import RetencionDelete from './RetencionDelete'
export {RetencionDelete}
export default RetencionDelete
